import { useState } from "react";
import { useProposalActions } from "./useProposalActions";
import { useProposalCompany } from "./useProposalCompany";

const identityCompany = (company) => company;

/**
 * Star flag, loaded company, and approve/download handlers for one proposal.
 * The details page logs each lookup. The modal maps profile fields before downloads use the brochure.
 */
export const useProposalReview = ({
  proposal,
  navigate,
  onComplete,
  userId,
  logProposal = false,
  requireUserId = false,
  onReject,
  mapCompany = identityCompany,
}) => {
  const [isStarred, setIsStarred] = useState(proposal?.esDestacado || false);
  const loaded = useProposalCompany({
    userId,
    navigate,
    proposalForLog: proposal,
    logProposal,
    requireUserId,
  });
  const company = mapCompany(loaded.company);
  const actions = useProposalActions({
    proposal,
    brochureUrl: company?.brochure,
    isStarred,
    setIsStarred,
    navigate,
    onComplete,
    onReject,
  });

  return {
    company,
    country: loaded.country,
    isStarred,
    neighborhood: loaded.neighborhood,
    sector: loaded.sector,
    state: loaded.state,
    town: loaded.town,
    zipCode: loaded.zipCode,
    ...actions,
  };
};
